export default __webpack_public_path__ + "static/media/empty-menu.bb1eb24c.svg";